<template>
  <div>
    <label
      v-show="support"
      ref="btn"
      class="uploader-btn"
    >
      <i class="el-icon-upload2" />
      <slot />
    </label>
    <div
      slot="tip"
      class="el-upload__tip"
    >
      <span class="upload-tip-item">
        {{ $t('common.upload.uploadTip', { formats: allowFileTypes.join('/') }) }}, {{ single ? $t('common.upload.single') : $t('common.upload.multiple') }}
      </span>
      <el-link
        v-if="markerExample"
        :href="markerExample"
        class="upload-tip-example"
        type="primary"
        :underline="false"
      >
        {{ $t('common.upload.example') }}
      </el-link>
    </div>
  </div>
</template>

<script>
import { uploaderMixin, supportMixin } from '../common/mixins'

const COMPONENT_NAME = 'uploader-btn'

export default {
  name: COMPONENT_NAME,
  mixins: [uploaderMixin, supportMixin],
  props: {
    directory: {
      type: Boolean,
      default: false
    },
    single: {
      type: Boolean,
      default: true
    },
    attrs: {
      type: Object,
      default () {
        return {}
      }
    },
    allowFileTypes: { // 最大文件大小 MB
      type: Array,
      default: () => {
        return []
      }
    },
    markerExample: {
      type: String,
      default () {
        return ''
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.uploader.uploader.assignBrowse(this.$refs.btn, this.directory, this.single, this.attrs)
    })
  }
}
</script>

<style>
  .uploader-btn {
    display: inline-block;
    position: relative;
    padding: 9px 15px;
    font-size: 14px;
    line-height: 1.4;
    color: #606266;
    border: 1px solid #DCDFE6;
    cursor: pointer;
    border-radius: 2px;
  }
  .uploader-btn:hover {
    color: var(--primary-color);
    border-color: var(--primary-color);
  }
  .el-upload__tip {
    display: inline-block;
    vertical-align: middle;
    margin-left: 20px;
    margin-top: 0;
  }
  .el-upload__tip .upload-tip-item {
      margin: 0;
      line-height: normal;
  }
  .upload-tip-example {
    color: var(--primary-color);
    font-size: 12px;
    margin-left: 20px;
  }
</style>
